import { string, shape, array, arrayOf } from "prop-types";
import { RichText } from "./RichText";
import styles from "./styles/RichTextSection.module.css";

export const RichTextSection = ({ data }) => {
  return (
    <section className={styles.container}>
      {data.header && <h2 className={styles.header}>{data.header}</h2>}
      <div className={styles.wrapper}>
        <RichText data={data.richText} />
      </div>
    </section>
  );
};

RichTextSection.propTypes = {
  _key: string,
  _type: string,
  header: string,
  richText: shape({
    _type: string,
    content: arrayOf(
      shape({
        _key: string,
        _type: string,
        style: string,
        children: arrayOf(
          shape({
            _key: string,
            _type: string,
            marks: array,
            text: string,
          })
        ),
        markDefs: array,
      })
    ),
  }),
};
